let IsoLocale;
(function (IsoLocale) {
  IsoLocale["svSE"] = "sv-SE";
  IsoLocale["svFI"] = "sv-FI";
  IsoLocale["daDK"] = "da-DK";
  IsoLocale["fiFI"] = "fi-FI";
  IsoLocale["nbNO"] = "nb-NO";
  IsoLocale["enGB"] = "en-GB";
  IsoLocale["deDE"] = "de-DE";
  IsoLocale["esES"] = "es-ES";
  IsoLocale["esMX"] = "es-MX";
  IsoLocale["ptBR"] = "pt-BR";
  IsoLocale["nlNL"] = "nl-NL";
  IsoLocale["frFR"] = "fr-FR";
  IsoLocale["itIT"] = "it-IT";
  IsoLocale["enUS"] = "en-US";
  IsoLocale["esUS"] = "es-US";
})(IsoLocale || (IsoLocale = {}));

export { IsoLocale };
//# sourceMappingURL=iso-locale.js.map
